import { Moon, Sun, Book } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTheme } from './theme-provider';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex items-center gap-1 rounded-lg bg-gray-100 p-1 dark:bg-gray-800">
      <motion.button
        onClick={() => setTheme('light')}
        className={`relative h-8 w-8 rounded-md p-1.5 ${
          theme === 'light'
            ? 'bg-white text-[#0056D2] shadow-sm'
            : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
        }`}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.1 }}
        title="Light Mode"
      >
        <Sun className="h-full w-full" />
      </motion.button>

      <motion.button
        onClick={() => setTheme('dark')}
        className={`relative h-8 w-8 rounded-md p-1.5 ${
          theme === 'dark'
            ? 'bg-white text-[#0056D2] shadow-sm dark:bg-gray-700 dark:text-white'
            : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
        }`}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.1 }}
        title="Dark Mode"
      >
        <Moon className="h-full w-full" />
      </motion.button>

      <motion.button
        onClick={() => setTheme('reading')}
        className={`relative h-8 w-8 rounded-md p-1.5 ${
          theme === 'reading'
            ? 'bg-[#FAF9F6] text-amber-600 shadow-sm'
            : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'
        }`}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.1 }}
        title="Reading Mode"
      >
        <Book className="h-full w-full" />
      </motion.button>
    </div>
  );
} 